import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Spinner from '../../components/common/Spinner';
import { useTranslation } from 'react-i18next';
import { getCoinAmount, getRate } from '../../helpers/Utils'
import AOS from "aos";
import "aos/dist/aos.css";

//btc, eth, bnb, ada, xrp, dot, mana, doge
//usdc, pnt, avax, busd, ltc, matic, algo, bch, bond, xlm, link, vet

const Coinone = ({search}) => {

  const [coins, setCoins] = useState([])
  
  useEffect(() => {
    AOS.init();    
    onInit();
  }, []);

  const onInit = async () => {
    const url = 'https://api.coinone.co.kr/ticker?currency=all';
        
    fetch(url)
    .then(response => response.json())
    .then(json => {
      var coins = [];
      if (json.find(n => n.symbol === 'BTC') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BTC') ];
        if (json.find(n => n.symbol === 'ETH') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'ETH') ];
      if (json.find(n => n.symbol === 'BNB') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BNB') ];
      if (json.find(n => n.symbol === 'ADA') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'ADA') ];
      if (json.find(n => n.symbol === 'XRP') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'XRP') ];
      if (json.find(n => n.symbol === 'DOT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'DOT') ];
      if (json.find(n => n.symbol === 'MANA') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'MANA') ];
      if (json.find(n => n.symbol === 'DOGE') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'DOGE') ];
      if (json.find(n => n.symbol === 'USDC') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'USDC') ];
      if (json.find(n => n.symbol === 'PNT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'PNT') ];
      if (json.find(n => n.symbol === 'AVAX') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'AVAX') ];
      if (json.find(n => n.symbol === 'BUSD') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BUSD') ];
      if (json.find(n => n.symbol === 'LTC') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'LTC') ];
      if (json.find(n => n.symbol === 'MATIC') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'MATIC') ];
      if (json.find(n => n.symbol === 'ALGO') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'ALGO') ];
      if (json.find(n => n.symbol === 'BCH') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BCH') ];
      if (json.find(n => n.symbol === 'BOND') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BOND') ];
      if (json.find(n => n.symbol === 'XLM') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'XLM') ];
      if (json.find(n => n.symbol === 'LINK') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'LINK') ];
      if (json.find(n => n.symbol === 'VET') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'VET') ];

      setCoins(coins); 
      

  });
  
  }
    
  return (
    <div className="mk_step2">
      <div className="mk_list">
        <div>Assets / Vol(24h)</div>
        <div>Price (USDT)</div>
        <div>24h Change</div>
      </div>
     { coins.filter( n => n.symbol.indexOf(search.toUpperCase()) !== -1 || n.symbol.indexOf(search.toLowerCase()) !== -1).map((item, i) => (
          <div className="mk_list" data-aos="fade-left" key={i}>
            <div><p>{item.symbol}</p><span>{getCoinAmount(item.volume24)}</span></div>
            { Number(item.priceChangePercent) >= 0?
            <div><b>{getCoinAmount(item.openPrice, 2)}</b></div>
            :<div><i>{getCoinAmount(item.openPrice, 2)}</i></div>
            }
            { Number(item.priceChangePercent) >= 0?
            <div><b>{item.priceChangePercent}</b></div>
            :<div><i>{item.priceChangePercent}</i></div>
            }
            
          </div>
        ))}
    </div>
  );
};


const Binance = ({search, setloaded}) => {

  const [coins, setCoins] = useState([])
  
  useEffect(() => {
    AOS.init();    
    
    onInit();
  }, []);

  const onInit = async () => {
    const url = 'https://api.binance.com/api/v3/ticker/24hr';
    fetch(url)
    .then(response => response.json())
    
    .then(json => {
      var coins = [];
      if (json.find(n => n.symbol === 'BTCUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BTCUSDT') ];
        if (json.find(n => n.symbol === 'ETHUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'ETHUSDT') ];
      if (json.find(n => n.symbol === 'BNBUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BNBUSDT') ];
      if (json.find(n => n.symbol === 'ADAUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'ADAUSDT') ];
      if (json.find(n => n.symbol === 'XRPUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'XRPUSDT') ];
      if (json.find(n => n.symbol === 'DOTUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'DOTUSDT') ];
      if (json.find(n => n.symbol === 'MANAUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'MANAUSDT') ];
      if (json.find(n => n.symbol === 'DOGEUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'DOGEUSDT') ];
      if (json.find(n => n.symbol === 'USDCUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'USDCUSDT') ];
      if (json.find(n => n.symbol === 'PNTUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'PNTUSDT') ];
      if (json.find(n => n.symbol === 'AVAXUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'AVAXUSDT') ];
      if (json.find(n => n.symbol === 'BUSDUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BUSDUSDT') ];
      if (json.find(n => n.symbol === 'LTCUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'LTCUSDT') ];
      if (json.find(n => n.symbol === 'MATICUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'MATICUSDT') ];
      if (json.find(n => n.symbol === 'ALGOUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'ALGOUSDT') ];
      if (json.find(n => n.symbol === 'BCHUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BCHUSDT') ];
      if (json.find(n => n.symbol === 'BONDUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'BONDUSDT') ];
      if (json.find(n => n.symbol === 'XLMUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'XLMUSDT') ];
      if (json.find(n => n.symbol === 'LINKUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'LINKUSDT') ];
      if (json.find(n => n.symbol === 'VETUSDT') !== undefined)
        coins =[...coins, json.find(n => n.symbol === 'VETUSDT') ];

      setCoins(coins); 
  });
  
  }
  return (
    <div className="mk_step2">
      <div className="mk_list">
        <div>Assets / Vol(24h)</div>
        <div>Price (USDT)</div>
        <div>24h Change</div>
      </div>
     { coins.filter( n => n.symbol.indexOf(search.toUpperCase()) !== -1 || n.symbol.indexOf(search.toLowerCase()) !== -1).map((item, i) => (
          <div className="mk_list" data-aos="fade-left" key={i}>
            <div><p>{item.symbol.replace('USDT', '')}</p><span>{getCoinAmount(item.volume)}</span></div>
            { Number(item.priceChangePercent) >= 0?
            <div><b>{getCoinAmount(item.openPrice)}</b></div>
            :<div><i>{getCoinAmount(item.openPrice)}</i></div>
            }
            { Number(item.priceChangePercent) >= 0?
            <div><b>{item.priceChangePercent}%</b></div>
            :<div><i>{item.priceChangePercent}%</i></div>
            }
            
          </div>
        ))}
    </div>
  );
};

const Bithumb = ({search}) => {

  const [coins, setCoins] = useState([])
  const [usdt_price, setUSDT] = useState(0);
  
  useEffect(() => {
    AOS.init();    
    onInit();
  }, []);

  const onInit = async () => {
    const url = 'https://api.bithumb.com/public/ticker/ALL';
        
    fetch(url)
    .then(response => response.json())
    .then(json => {
      var coins = [];
      let newcoins;
      
      newcoins = json.data['BTC'];
      newcoins.symbol = 'BTC';
      coins =  [...coins, newcoins ];

      newcoins = json.data['ETH'];
      newcoins.symbol = 'ETH';
      coins =  [...coins, newcoins ];

      newcoins = json.data['BNB'];
      newcoins.symbol = 'BNB';
      coins =  [...coins, newcoins ];

      newcoins = json.data['XRP'];
      newcoins.symbol = 'XRP';
      coins =  [...coins, newcoins ];

      newcoins = json.data['DOT'];
      newcoins.symbol = 'DOT';
      coins =  [...coins, newcoins ];

      newcoins = json.data['MANA'];
      newcoins.symbol = 'MANA';
      coins =  [...coins, newcoins ];

      newcoins = json.data['DOGE'];
      newcoins.symbol = 'DOGE';
      coins =  [...coins, newcoins ];

      newcoins = json.data['AVAX'];
      newcoins.symbol = 'AVAX';
      coins =  [...coins, newcoins ];

      newcoins = json.data['MATIC'];
      newcoins.symbol = 'MATIC';
      coins =  [...coins, newcoins ];

      newcoins = json.data['ALGO'];
      newcoins.symbol = 'ALGO';
      coins =  [...coins, newcoins ];

      newcoins = json.data['BCH'];
      newcoins.symbol = 'BCH';
      coins =  [...coins, newcoins ];

      newcoins = json.data['XLM'];
      newcoins.symbol = 'XLM';
      coins =  [...coins, newcoins ];

      newcoins = json.data['LINK'];
      newcoins.symbol = 'LINK';
      coins =  [...coins, newcoins ];

      newcoins = json.data['VET'];
      newcoins.symbol = 'VET';
      coins =  [...coins, newcoins ];

      newcoins = json.data['USDC'];
      newcoins.symbol = 'USDC';
      coins =  [...coins, newcoins ];

      newcoins = json.data['USDT'];
      newcoins.symbol = 'USDT';
      setUSDT(newcoins.opening_price)
      coins =  [...coins, newcoins ];
      
      setCoins(coins); 
  });
  
  }
  return (
    <div className="mk_step2">
      <div className="mk_list">
        <div>Assets / Vol(24h)</div>
        <div>Price (USDT)</div>
        <div>24h Change</div>
      </div>
      { coins.filter( n => n.symbol.indexOf(search.toUpperCase()) !== -1 || n.symbol.indexOf(search.toLowerCase()) !== -1).map((item, i) => (
            <div className="mk_list" data-aos="fade-left" key={i}>
              <div><p>{item.symbol}</p><span>{getCoinAmount(item.acc_trade_value_24H /  usdt_price)}</span></div>
              { Number(item.fluctate_rate_24H) >= 0?
              <div><b>{getCoinAmount(item.opening_price / usdt_price)}</b></div>
              :<div><i>{getCoinAmount(item.opening_price  / usdt_price)}</i></div>
              }
              { Number(item.fluctate_rate_24H) >= 0?
              <div><b>{item.fluctate_rate_24H}%</b></div>
              :<div><i>{item.fluctate_rate_24H}%</i></div>
              }
              
            </div>
          ))}
    </div>
    
  );
};

const Coinlore = ({search}) => {

  const [coins, setCoins] = useState([])
  
  useEffect(() => {
    AOS.init();    
    onInit();
  }, []);
    
  const onInit = async () => {
    const url = 'https://api.coinlore.net/api/tickers/?start=0&limit=30';
        
    fetch(url)
    .then(response => response.json())
    .then(json => {
      setCoins(json.data); // 가져온 데이터 1~100위 담기
  });
  }

  return (
    <div className="mk_step2">
    <div className="mk_list">
      <div>Assets / Vol(24h)</div>
      <div>Price (USDT)</div>
      <div>24h Change</div>
    </div>

    { coins.filter( n => n.symbol.indexOf(search.toUpperCase()) !== -1 || n.symbol.indexOf(search.toLowerCase()) !== -1).map((item, i) => (
          <div className="mk_list" data-aos="fade-left" key={i}>
            <div><p>{item.symbol}</p><span>{getCoinAmount(item.volume24)}</span></div>
            { Number(item.percent_change_24h) >= 0?
            <div><b>{getCoinAmount(item.price_usd)}</b></div>
            :<div><i>{getCoinAmount(item.price_usd)}</i></div>
            }
            { Number(item.percent_change_24h) >= 0?
            <div><b>{getRate(item.percent_change_24h)}</b></div>
            :<div><i>{getRate(item.percent_change_24h)}</i></div>
            }
            
          </div>
        ))}
  </div>
  );
};

const Upbit = ({search, setloaded}) => {

  const [coins, setCoins] = useState([])
  
  useEffect(() => {
    onInit();
    
  }, []);
    
  const onInit = async () => {

    var coins = [];
    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-BTC')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "BTC";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-ETH')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "ETH";
      coins =  [...coins, json[0] ];
    });
    
    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-ADA')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "ADA";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-DOT')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "DOT";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-MANA')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "MANA";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-DOGE')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "DOGE";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-AVAX')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "AVAX";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-MATIC')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "MATIC";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-ALGO')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "ALGO";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-BCH')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "BCH";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-XLM')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "LTC";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-LINK')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "LINK";
      coins =  [...coins, json[0] ];
    });

    await fetch('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-VET')
    .then(response => response.json())
    .then(json => {
      json[0].symbol = "VET";
      coins =  [...coins, json[0] ];
    });

    setCoins(coins)

  }
  return (
    <div className="mk_step2">
    <div className="mk_list">
      <div>Assets / Vol(24h)</div>
      <div>Price (KRW)</div>
      <div>24h Change</div>
    </div>

    { coins.filter( n => n.symbol.indexOf(search.toUpperCase()) !== -1 || n.symbol.indexOf(search.toLowerCase()) !== -1).map((item, i) => (
          <div className="mk_list" data-aos="fade-left" key={i}>
            <div><p>{item.symbol}</p><span>{getCoinAmount(item.candleAccTradeVolume)}</span></div>
            { Number(item.signedChangeRate) >= 0?
            <div><b>{getCoinAmount(item.tradePrice)}</b></div>
            :<div><i>{getCoinAmount(item.tradePrice)}</i></div>
            }
            { Number(item.signedChangeRate) >= 0?
            <div><b>{getRate(item.signedChangeRate)}%</b></div>
            :<div><i>{getRate(item.signedChangeRate)}%</i></div>
            }
            
          </div>
        ))}
  </div>
  );
};

const Market = (props) => {
  const [isLoaded, setIsLoaded] = useState(true);
  const [search, setSearch] = useState('');
  const [exchangeName, setLender] = useState('binance');
  
  const { t } = useTranslation();
  const marketData = [
    {exchangeName : 'coinone', render : <Coinone search ={search} setloaded={setIsLoaded}/> },
    {exchangeName: 'coinlore', render : <Coinlore search ={search} setloaded={setIsLoaded}/> },
    {exchangeName: 'upbit', render : <Upbit search ={search} setloaded={setIsLoaded}/> },
    {exchangeName: 'binance', render : <Binance search ={search} setloaded={setIsLoaded}/> },
    {exchangeName: 'bithumb', render : <Bithumb search ={search} setloaded={setIsLoaded}/> }
  ]
  
  useEffect(() => {
  }, [search]);
    
  /*
      case 'bithumb'        : setUrl('https://api.bithumb.com/public/ticker/ALL'); break; //ALL 대신 원하는 암호화폐 심볼을 입력시 원하는 데이터를 호출
      case 'coinmarketcap'  : setUrl('ttps://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-BTC'); break; // KRW-BTC 대신 원하는 마켓 및 심볼을 입력하면 원하는 데이터를 호출
      case 'upbit'          : setUrl('https://crix-api-endpoint.upbit.com/v1/crix/candles/days/?code=CRIX.UPBIT.KRW-BTC'); break; // 데이터를 시총순서대로 불러오고 있음, limit=뒤의 숫자를 변경하여 원하는 개수만큼 불러오기 가능
      case 'coinone'        : setUrl('https://api.coinone.co.kr/ticker?currency=all'); break; //all 대신 원하는 심볼을 입력하여 호출, 코인원은 대문자가 아닌 소문자를 취급
      case 'poloniex'       : setUrl('https://poloniex.com/public?command=returnTicker'); break; //현재 폴로닉스에서 거래중인 암호화폐 정보를 모두 출력
      case 'binance'        : setUrl('https://api.binance.com/api/v1/ticker/allPrices'); break; //allPrices 대신 원하는 심볼을 입력하여 데이터를 호출
      case 'korbit'         : setUrl('https://api.korbit.co.kr/v1/ticker?currency_pair=btc_krw'); break; //btc-krw 대신 원하는 심볼을 입력하여 호출, 코인원과 마찬가지로 소문자를 취급
      default : setUrl('https://api.coinlore.net/api/tickers/?start=0&limit=30'); break;
    }
  }
  */


  return !isLoaded ? (
    <Spinner />
  ) : (
    <section>
    <div className="mdt_wrap">
      <div className="mk_step1">
      <div className="mk_coin">
        <div href="" className="coin_bt"><img src="images/icon_coin1.svg" onClick={()=> setLender('binance')} alt="" /></div>
        <div href="" className="coin_bt"><img src="images/icon_coin2.svg" onClick={()=> setLender('bithumb')}alt="" /></div>

        <div href="" className="coin_bt"><img src="images/icon_coin4.svg" onClick={()=> setLender('upbit')}alt="" /></div>
      </div>
      <div className="mk_search">
        <input 
          type="text" 
          className="inp1"
          placeholder={t('search')} 
          value={search} 
          onChange={e => setSearch(e.target.value)}
        />

        <button type="button" className="btty1"><img src="images/icon_search.svg" alt={t('search')}  /></button>
      </div>
     </div>
      {marketData.find(n => n.exchangeName === exchangeName).render}
    </div>
    
    </section>
    
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser } = authUser;
  return {currentUser}
};

export default connect(mapStateToProps, null)(Market);

